import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { IPaginationPayload } from '../../interfaces/shared/IPaginationPayload';
import Table from '../../shared/table';
import { useAccountManagementDetailsMutation } from '../../store/chatbox/chatboxApi';

const tableColumns = [
    'Timestamp',
    'User',
    'Query',
    'Document',
    'Client',
    'Agent',
    'Rating',
];

const QueriesTable = ({
	hotelId
}: {
	hotelId: string
}) => {
	
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
        filters: 'all',
    });
    const [accountManagementDetails, { data }] =
        useAccountManagementDetailsMutation();

    const getAccountDetails = async () => {
        try {
            await accountManagementDetails({
                ...paginationState,
                hotelId
            }).unwrap();
        } catch (e) {
            console.log({ e });
        }
    };

    console.log({ data });

    useEffect(() => {
        getAccountDetails();
    }, [paginationState, hotelId]);

    const rows = data?.data.elements || [];

    return (
        <>
            <div className="flex flex-wrap items-center my-4">
                <h4 className="px-2 text-sm font-semibold">
                    Showing {data?.data.page.totalElements} queries
                </h4>
            </div>
            <Table
                columns={tableColumns}
                paginationData={data?.data.page}
                setPaginationState={setPaginationState}
                containerStyle="border p-2 rounded-xl">
                {rows?.length > 0 &&
                    rows?.map((row, idx: number) => {
                        return (
                            <tr
                                key={idx}
                                className="bg-white border-b hover:bg-gray-50 text-black text-sm">
                                <td className="px-6 py-4">
                                    {moment(row?.createdAt).format(
                                        'DD-MM-YYYY hh:mm:ss',
                                    )}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.userInfo.email}{' '}
                                </td>
                                <td className="px-6 py-4"> {row.query} </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.sources.map((source) => (
                                        <div
                                            key={source}
                                            className="bg-gray-100 p-1 rounded">
                                            {source}
                                        </div>
                                    ))}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.hotelInfo.name}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {' '}
                                    {row.agent.name}{' '}
                                </td>
                                <td className="px-6 py-4">
                                    {row.liked ? (
                                        <img
                                            alt="liked"
                                            src="/assets/chat/liked.svg"
                                        />
                                    ) : (
                                        <></>
                                    )}
                                    {row.disliked ? (
                                        <img
                                            alt="liked"
                                            src="/assets/chat/disliked.svg"
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
            </Table>
        </>
    );
};

export default QueriesTable;
